module.exports = __webpack_public_path__ + "img/credit-plus-ua.f6824788.svg";